import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=61c4a3e4&scoped=true"
import script from "./DashboardTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardTable.vue?vue&type=style&index=0&id=61c4a3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4a3e4",
  null
  
)

export default component.exports